/**
 * De dónde salen las fichas de las secciones «listing» y «menu». En un sitio simple vienen de content/industry.ts;
 * en un sitio con contenido administrable vienen del servidor de contenido (content/remote.ts) con respaldo estático.
 */
import type { ListingItem, ListingSection, MenuSection } from "./industry";

export function useListingItems(section: ListingSection): ListingItem[] {
  return section.items;
}

export function useMenuCategories(section: MenuSection): MenuSection["categories"] {
  return section.categories;
}
